"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_STORAGE_KEY = exports.baseQueryWithReauth = void 0;
var query_1 = require("@reduxjs/toolkit/query");
var auth_1 = require("../features/slices/auth");
var AUTH_STORAGE_KEY = "sky_auth";
exports.AUTH_STORAGE_KEY = AUTH_STORAGE_KEY;
var baseQueryWithReauth = function (customBaseUrl) {
    return function (args, store, extraOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var baseQuery, result, url, isAuthEndpoint, isTokenExpired, refreshResult, _a, success, content, storedAuth, parsed;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    baseQuery = (0, query_1.fetchBaseQuery)({
                        baseUrl: customBaseUrl,
                        prepareHeaders: function (headers, _a) {
                            var getState = _a.getState;
                            var auth = getState().auth;
                            var token = auth.token;
                            if (token) {
                                headers.set("Authorization", "Bearer ".concat(token));
                            }
                            return headers;
                        },
                    });
                    return [4 /*yield*/, baseQuery(args, store, extraOptions)];
                case 1:
                    result = _d.sent();
                    url = typeof args === "string" ? args : args.url;
                    isAuthEndpoint = (url === null || url === void 0 ? void 0 : url.includes("/auth/login")) || (url === null || url === void 0 ? void 0 : url.includes("/auth/refresh"));
                    if (isAuthEndpoint) {
                        return [2 /*return*/, result];
                    }
                    isTokenExpired = (result.error &&
                        (result.error.status === 401 ||
                            (result.error.data &&
                                typeof result.error.data === "object" &&
                                "message" in result.error.data &&
                                ((_b = result.error.data.message) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes("token expired"))))) ||
                        (result.data &&
                            typeof result.data === "object" &&
                            "success" in result.data &&
                            "message" in result.data &&
                            !result.data.success &&
                            ((_c = result.data.message) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes("token expired")));
                    if (!isTokenExpired) return [3 /*break*/, 7];
                    return [4 /*yield*/, baseQuery({
                            url: "/v1/auth/refresh",
                            method: "POST",
                        }, store, extraOptions)];
                case 2:
                    refreshResult = _d.sent();
                    if (!refreshResult.data) return [3 /*break*/, 6];
                    _a = refreshResult.data, success = _a.success, content = _a.content;
                    if (!(success && content)) return [3 /*break*/, 4];
                    // Update token in store
                    store.dispatch((0, auth_1.updateToken)({
                        token: content.token,
                        expires_at: content.expires_at,
                    }));
                    storedAuth = localStorage.getItem(AUTH_STORAGE_KEY);
                    if (storedAuth) {
                        parsed = JSON.parse(storedAuth);
                        parsed.token = content.token;
                        parsed.expires_at = content.expires_at;
                        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(parsed));
                    }
                    return [4 /*yield*/, baseQuery(args, store, extraOptions)];
                case 3:
                    // Retry the original query with new token
                    result = _d.sent();
                    return [3 /*break*/, 5];
                case 4:
                    // Refresh failed - clear credentials and redirect to login
                    store.dispatch((0, auth_1.clearCredentials)());
                    localStorage.removeItem(AUTH_STORAGE_KEY);
                    // Use replace instead of href to avoid adding to history
                    window.location.replace("/login");
                    return [2 /*return*/, result];
                case 5: return [3 /*break*/, 7];
                case 6:
                    if (refreshResult.error && refreshResult.error.status === 401) {
                        // Refresh request also returned 401 - token is definitely expired
                        store.dispatch((0, auth_1.clearCredentials)());
                        localStorage.removeItem(AUTH_STORAGE_KEY);
                        window.location.replace("/login");
                        return [2 /*return*/, result];
                    }
                    else {
                        // Refresh request failed - clear credentials
                        store.dispatch((0, auth_1.clearCredentials)());
                        localStorage.removeItem(AUTH_STORAGE_KEY);
                        window.location.replace("/login");
                        return [2 /*return*/, result];
                    }
                    _d.label = 7;
                case 7: return [2 /*return*/, result];
            }
        });
    }); };
};
exports.baseQueryWithReauth = baseQueryWithReauth;
